import { allClientSideFlags } from '@gonfalon/constants/constants';
import { getDogfoodClient } from '@gonfalon/dogfood-client/getDogfoodClient';
import type { DogfoodClient } from '@gonfalon/dogfood-client/types';

export function createFlagFunction<T>(flagKey: string, defaultValue: T): () => T {
  return () => {
    let client: DogfoodClient | undefined;

    try {
      client = getDogfoodClient();
    } catch {
      const flagValue = allClientSideFlags()[flagKey];

      if (typeof flagValue === 'undefined') {
        if (!window.__TEST__) {
          // oxlint-disable-next-line no-console
          console.error(`Flag "${flagKey}" not defined in client-side flags`);
        }

        return defaultValue;
      }

      return flagValue as T;
    }

    return client.variation(flagKey, defaultValue) as T;
  };
}
